import { render, staticRenderFns } from "./commands.vue?vue&type=template&id=35563084&scoped=true"
import script from "./commands.vue?vue&type=script&lang=js"
export * from "./commands.vue?vue&type=script&lang=js"
import style0 from "./commands.vue?vue&type=style&index=0&id=35563084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35563084",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/build/components/Heading.vue').default,TabPane: require('/build/components/TabPane.vue').default,Tab: require('/build/components/Tab.vue').default,Card: require('/build/components/Card.vue').default,BaseInput: require('/build/components/BaseInput.vue').default})
